import Vue from 'vue'
import App from './App.vue'
import Projects from './components/Projects.vue'
import Read from './components/Read.vue'
import About from './components/About.vue'
import Recent from './components/Recent.vue'
import VueRouter from 'vue-router'
import Clipboard from 'v-clipboard'
 
import './assets/tailwind.css'

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(Clipboard)

const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: Recent,
    },
    {
      path: '/projects',
      component: Projects
    },
    {
      path: '/read',
      component: Read
    },
    {
      path: '/about',
      component: About
    }
  ]
})

router.afterEach((to) => {
  const titles = {
    '/': 'Gagan Ajjikuttira — Engineer, Builder, Daydreamer',
    '/projects': 'Selected Work — Gagan Ajjikuttira',
    '/read': 'Writing — Gagan Ajjikuttira',
    '/about': 'About — Gagan Ajjikuttira',
  }

  document.title = titles[to.path] || titles['/']
})

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
